import React, { useState, useEffect } from "react";
import {
  Button,
  Checkbox,
  MultiSelect,
  Select,
  Text,
  Group,
  ThemeIcon,
  Title,
  Divider,
  Paper,
} from "@mantine/core";

import { IconUsers, IconCheck } from "@tabler/icons-react";
import { showNotification } from "@mantine/notifications";
import { BeatLoader } from "react-spinners";
import {
  loadingStates,
  validateEmail,
  validateMobile,
} from "../../utilities/utilities";
import colors from "../../utilities/design";
import { getUserRolesUsingRoleId } from "../../utilities/apis/serviceProvider";
import {
  getAgreementDetails,
  getuserIdbyMail,
  putflowJson,
} from "../../utilities/apis/agreements";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";

const mapping = {
  Initiator: "3",
  Editor: "4",
  Reviewer: "5",
  Approver: "6",
  SigningAuthority: "7",
};

const AgreementForm5 = ({
  flowData,
  setFlowData,
  form,
  setUiConfigs,
  uiConfigs,
  save,
  id,
}) => {
  const currentUser = useSelector(selectUserData);
  const [isLoading, setIsLoading] = useState(true);
  const [userRolesIdData, setUserRolesIdData] = useState({
    userRoles: {
      Initiator: [],
      Editor: [],
      Reviewer: [],
      Approver: [],
      SigningAuthority: [],
    },
  });
  const [checked, setChecked] = useState(false);
  const [dataRole, setDataRole] = useState(flowData);
  const [errors, setErrors] = useState({});

  const fieldStyles = {
    label: {
      fontWeight: 500,
      marginBottom: 6,
      textTransform: "none",
    },
    input: {
      height: 44,
    },
    error: {
      fontSize: 12,
      textTransform: "none",
    },
  };

  //console.log("data role: ", dataRole);
  useEffect(() => {
    setDataRole({ ...dataRole, sendfordirectsign: checked });
    // form.setValues((prevValues) => {
    //   const currentValues = flat.unflatten(prevValues);

    //   // Check if firstParty.name exists
    //   if (!currentValues.firstParty?.name) {
    //     return flat({
    //       ...currentValues,
    //       firstParty: {
    //         address: orgDetails.address,
    //         corporateOfficeAddress: budetails.copAddress,
    //         email: budetails.signEmail,
    //         entityType: orgDetails.entityType,
    //         name: orgDetails.name,
    //         representative: budetails.poc,
    //         signatory: budetails.signName,
    //         type: "Entity",
    //       },
    //     });
    //   }
    // });
  }, [checked]);
  console.log(form);
  useEffect(() => {
    const fetchData = async () => {
      const agreementId = id;
      const { data } = await getAgreementDetails({ agreementId });
      const fetchedDataRole = data.agreement.flowJson;

      if (fetchedDataRole) {
        setDataRole(fetchedDataRole);
      } else {
        const loginAsId = Number(currentUser.loginAs.id); // Ensure it's a number
        if (loginAsId === 4 || loginAsId === 3) {
          const selectedData = [
            {
              userId: currentUser.id,
              isComplete: checked ? true : false,
            },
          ];
          setDataRole((prevDataRole) => ({
            ...prevDataRole,
            [loginAsId + ""]: selectedData,
          }));
        }
      }
    };

    fetchData();
  }, [id, checked, currentUser.loginAs.id]);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const roles = {
          Initiator: (await getUserRolesUsingRoleId(3)).data.result,
          Editor: (await getUserRolesUsingRoleId(4)).data.result,
          Reviewer: (await getUserRolesUsingRoleId(5)).data.result,
          Approver: (await getUserRolesUsingRoleId(6)).data.result,
          SigningAuthority: (await getUserRolesUsingRoleId(7)).data.result,
        };

        setUserRolesIdData((prevData) => ({
          ...prevData,
          userRoles: roles,
        }));
      } catch (error) {
        console.error("Error fetching user roles:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserRoles();
  }, []);

  const savePrev = async () => {
    if (true) {
      setUiConfigs({
        ...uiConfigs,
        currentStep: 2,
      });
    }
  };

  const validateForm = () => {
    const validationErrors = {};

    if (!checked && !dataRole["4"]?.length) {
      validationErrors.editor = "Please select an editor.";
    }

    if (!dataRole["7"]?.length) {
      validationErrors.signingAuthority =
        "Please select at least one signing authority.";
    }

    if (dataRole["7"]?.length > 2) {
      validationErrors.signingAuthority =
        "Maximum two signing authorities are allowed.";
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length) {
      showNotification({
        color: "red",
        title: "Validation Error",
        message: "Please correct the highlighted fields before continuing.",
      });

      return;
    }

    return Object.keys(validationErrors).length === 0;
  };

  const saveNext = async () => {
    validateForm();

    if (Object.keys(validationErrors).length) return;
    if (
      (checked &&
        (!dataRole["7"] ||
          dataRole["7"].length === 0 ||
          dataRole["7"].length > 2)) ||
      (!checked &&
        (!dataRole["4"] ||
          dataRole["4"].length === 0 ||
          !dataRole["7"] ||
          dataRole["7"].length === 0 ||
          dataRole["7"].length > 2))
    ) {
      return;
    }

    // form.setFieldValue("flowJson", dataRole);
    // await save({ ...form.values, formCompleted: true });
    // await apiWrapWithErrorWithData(putflowJson(id, dataRole));
    setUiConfigs({
      ...uiConfigs,
      currentStep: 4,
    });
  };

  const updateClick = async () => {
    validateForm();
    if (
      (checked &&
        (!dataRole["7"] ||
          dataRole["7"].length === 0 ||
          dataRole["7"].length > 2)) ||
      (!checked &&
        (!dataRole["4"] ||
          dataRole["4"].length === 0 ||
          !dataRole["7"] ||
          dataRole["7"].length === 0 ||
          dataRole["7"].length > 2))
    ) {
      return;
    }

    // form.setFieldValue("flowJson", dataRole);
    // await save({ ...form.values, formCompleted: true });
    try {
      await apiWrapWithErrorWithData(putflowJson(id, dataRole));
      showNotification({
        color: "green",
        title: "Update User Roles",
        message: "User Roles Updated.",
      });
      setUiConfigs({
        ...uiConfigs,
        currentStep: 4,
      });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  //     console.log("form: ", form.values["firstParty.email"] );
  //     const getuserId = async()=>{
  //       if(form.values["firstParty.email"]){
  //       const resp = await apiWrapWithErrorWithData(getuserIdbyMail({email: form.values["firstParty.email"]}));
  //       if(resp.success){
  //         console.log("succcess hu thaa bhai ");
  //         const data = [{userId: resp.id, isComplete : false}]
  //         setDataRole((prevDataRole) => ({
  //           ...prevDataRole,
  //           ["7"]: data,
  //         }));
  //       }
  //       }
  //     }
  // useEffect(()=>{
  //   getuserId();
  // }, [])

  const handleSelectChange = (role, selectedUser) => {
    const mappingRole = mapping[role];
    const selectedData = selectedUser
      ? [
          {
            userId: selectedUser,
            isComplete: false,
          },
        ]
      : [];

    setDataRole((prevDataRole) => ({
      ...prevDataRole,
      [mappingRole]: selectedData,
    }));
  };

  console.log(currentUser);

  const handleSelectDeselect = (role) => {
    const mappingRole = mapping[role];
    setDataRole((prevDataRole) => ({
      ...prevDataRole,
      [mappingRole]: [],
    }));
  };
  const handleMultiSelectChange = (role, selectedUsers) => {
    const mappingRole = mapping[role];

    const selectedData = selectedUsers.map((userId) => {
      const existingUser = dataRole[mappingRole]?.find(
        (user) => user.userId === userId,
      );
      return {
        userId,
        isComplete: existingUser ? existingUser.isComplete : false,
      };
    });

    setDataRole((prevDataRole) => ({
      ...prevDataRole,
      [mappingRole]: selectedData,
    }));
  };

  //console.log(dataRole);
  //console.log(checked);

  return (
    <div className="w-full flex flex-col my-4">
      <Group justify="space-between" mb="xl">
        <Group gap="md">
          <ThemeIcon radius="xl" variant="light" size={44}>
            <IconUsers size={20} />
          </ThemeIcon>

          <div>
            <Title order={4}>Roles & Permissions</Title>

            <Text size="sm" c="dimmed">
              Assign users responsible for reviewing, approving and signing this
              contract.
            </Text>
          </div>
        </Group>
      </Group>

      <Divider mb="xl" />
      <Paper withBorder radius="lg" shadow="xs" p="xl">
        {currentUser.loginAs.id === 3 && (
          <Checkbox
            checked={checked}
            label="Send for signature directly"
            onChange={(event) => setChecked(event.currentTarget.checked)}
            size="xl"
            radius="md"
            styles={fieldStyles}
          />
        )}
        <div
          className="grid grid grid-cols-1
        md:grid-cols-2
        xl:grid-cols-2
        gap-x-8
        gap-y-6"
        >
          {isLoading ? (
            <div className="col-span-3 flex justify-center">
              <BeatLoader color={colors.primary} size={10} />
            </div>
          ) : (
            <>
              <Select
                size="md"
                radius="md"
                styles={fieldStyles}
                key="Initiator"
                label="Initiator"
                className="mt-8"
                placeholder="Select Initiator"
                value={dataRole["3"]?.[0]?.userId || null}
                onChange={(selectedUser) =>
                  handleSelectChange("Initiator", selectedUser)
                }
                data={userRolesIdData.userRoles.Initiator.map((user) => ({
                  value: user.id,
                  label: user.name,
                }))}
                allowDeselect
                //onDeselect={() => handleSelectDeselect("Initiator")}
              />
              {!checked && (
                <Select
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  key="Editor"
                  label="Editor"
                  className="mt-8"
                  placeholder="Select Editor"
                  value={dataRole["4"]?.[0]?.userId}
                  onChange={(selectedUser) => {
                    handleSelectChange("Editor", selectedUser);

                    setErrors((prev) => ({
                      ...prev,
                      editor: undefined,
                    }));
                  }}
                  data={userRolesIdData.userRoles.Editor.map((user) => ({
                    value: user.id,
                    label: user.name,
                  }))}
                  allowDeselect
                  //onDeselect={() => handleSelectDeselect("Editor")}
                  required={!checked}
                  error={errors.editor}
                />
              )}
              {!checked && (
                <MultiSelect
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  key="Reviewer"
                  label="Reviewer(s)"
                  className="mt-8"
                  placeholder="Select Reviewer(s)"
                  value={dataRole["5"]?.map(({ userId }) => userId) || []}
                  onChange={(selectedUsers) =>
                    handleMultiSelectChange("Reviewer", selectedUsers)
                  }
                  data={userRolesIdData.userRoles.Reviewer.map((user) => ({
                    value: user.id,
                    label: user.name,
                  }))}
                />
              )}
              {!checked && (
                <MultiSelect
                  size="md"
                  radius="md"
                  styles={fieldStyles}
                  key="Approver"
                  label="Approver(s)"
                  className="mt-8"
                  placeholder="Select Approver(s)"
                  value={dataRole["6"]?.map(({ userId }) => userId) || []}
                  onChange={(selectedUsers) =>
                    handleMultiSelectChange("Approver", selectedUsers)
                  }
                  data={userRolesIdData.userRoles.Approver.map((user) => ({
                    value: user.id,
                    label: user.name,
                  }))}
                />
              )}
              {/* <MultiSelect
              key="SigningAuthority"
              label="signing authority"
              className="mt-8"
              placeholder="signing authority"
              value={dataRole["7"]?.map(({ userId }) => userId) || []}
              onChange={(selectedUsers) =>
                handleMultiSelectChange("SigningAuthority", selectedUsers)
              }
              data={userRolesIdData.userRoles.SigningAuthority.map((user) => ({
                value: user.id,
                label: user.name,
              }))}
              maxSelectedValues={2}
              required
              error={errors.signingAuthority}
            /> */}
              {/*<div></div>
            {uiConfigs.loading !== loadingStates.LOADING && (
              <div className="flex justify-end">
                <Button
                  className="mt-14 align-right "
                  onClick={updateClick}
                  color="green"
                >
                  update
                </Button>
              </div>
            )}*/}
            </>
          )}
        </div>
      </Paper>
      <div
        style={{
          marginTop: 40,
          paddingTop: 24,
          borderTop: "1px solid #E9ECEF",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        {uiConfigs.loading === loadingStates.LOADING ? (
          <BeatLoader color={colors.primary} size={10} />
        ) : (
          <>
            <Button variant="outline" radius="md" onClick={savePrev}>
              Previous
            </Button>
            <div className="flex flex-row">
              <Button
                radius="md"
                px={30}
                onClick={updateClick}
                variant="contained"
              >
                Next →
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AgreementForm5;
